import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import { InlineSpinner } from "components/base/Spinner";
import NavigationBar from "components/shared/NavigationBar";
import { useParams, useSearchParams } from "react-router-dom";
import { FETCH_CHINA_V2_PRODUCT } from "./graphql";
import ProductStockHistoryTableView from "./ProductStockHistoryTableView";

const ProductStockHistoryPage = () => {
  const { supplierId, productId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams({});
  const { loading, error, data } = useQuery(FETCH_CHINA_V2_PRODUCT, {
    variables: { supplierId, productId },
    fetchPolicy:
      process.env.NODE_ENV === "development" ? "cache-first" : "network-only",
  });
  const updateSearchParam = (key, value) => {
    const next = new URLSearchParams(searchParams);
    if (value == null || value === "") {
      next.delete(key);
    } else {
      next.set(key, value);
    }
    setSearchParams(next);
  };

  const q = searchParams.get("q") || "";

  if (loading)
    return (
      <div className="relative p-20">
        <InlineSpinner />
      </div>
    );
  if (error) return <Errors error={error} />;

  return (
    <div className="flex flex-col h-full space-y-4 pb-6">
      <NavigationBar
        title={`${data.supplier.name} / ${data.product.number}`}
        backTo="./.."
      />

      <div className="flex items-center mx-6 gap-4">
        <div className="flex-1">
          <SearchBar
            value={q}
            placeholder="Search by name / origin"
            onChange={(nextQ) => updateSearchParam("q", nextQ)}
          />
        </div>
      </div>

      <ProductStockHistoryTableView
        supplierId={supplierId}
        productId={productId}
        q={q}
      />
    </div>
  );
};

export default ProductStockHistoryPage;
